/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSSVariableValue} from '../../../assets/ts/_utils'

type Props = {
  className: string
  chartColor: string
  chartHeight: string
  chartScore: number
  chartTitle: string
}

const MixedWidget7: React.FC<Props> = ({className, chartColor, chartHeight, chartScore, chartTitle}) => {

  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, chartScore))
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, chartScore])

  return (
      <div className={`card ${className}`}>

        {/* begin::Body */}
        <div className="card-body d-flex flex-column">
          <div className="flex-grow-1">
            <div ref={chartRef} className="mixed-widget-4-chart"></div>
          </div>
          <span className="fw-bolder mb-1 fs-6 text-center">{chartTitle ? chartTitle : ''}</span>
        </div>
        {/* end::Body */}
      </div>
  )
}

const chartOptions = (chartColor: string, chartHeight: string, chartScore: number): ApexOptions => {
  const baseColor = getCSSVariableValue('--bs-' + chartColor)
  const lightBaseColor = baseColor + '22'
  const trackColor = getCSSVariableValue('--bs-gray-100')

  return {
    series: [chartScore],
    chart: {
      fontFamily: 'inherit',
      height: chartHeight,
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '65%',
          background: lightBaseColor
        },
        dataLabels: {
          name: {
            show: false,
            fontWeight: '700',
          },
          value: {
            color: baseColor,
            fontSize: '23px',
            fontWeight: '500',
            offsetY: 8,
            show: true,
            formatter: function(val) {
              return val + '%'
            },
          },
        },
        track: {
          background: trackColor,
          strokeWidth: '100%',
        },
      },
    },
    colors: [baseColor],
    stroke: {
      lineCap: 'round',
    },
    labels: ['Progress'],
  }
}

export {MixedWidget7}
